module.exports = __webpack_public_path__ + "static/media/backIcon.bdafa5fc.svg";